import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=f1ddf1bc&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style1 from "./Header.vue?vue&type=style&index=1&id=f1ddf1bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ddf1bc",
  null
  
)

export default component.exports